import { v4 as uuidv4 } from "uuid";
import { Dealer } from "./Dealer.model";
import { Template } from "./Template.entity";
import { VenueGroupVenue } from "./VenueGroupVenue.entity";

export class VenueGroup {
	key: string = uuidv4();
	name: string;
	dealerKey: string;
	created: Date = new Date();

	VenueGroupVenue: VenueGroupVenue[];

	Template: Template[];

	Dealer: Dealer;

	public constructor(init?: Partial<VenueGroup>) {
		Object.assign(this, init);
	}
}
